import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL

export const readNotificationUser = async (id: string, token: string) => {
    return axios.put(`${API_URL}crm-notifications/${id}/read`, {}, {
      headers: {
        'X-Auth-token': token,
      },
    });
  }
  
  export const readAllNotificationUser = async (token: string) => {
    return axios.post(`${API_URL}crm-notifications/read-all`, {}, {
      headers: {
        'X-Auth-token': token,
      },
    });
  }